(function($){
	var $mainHasCategories = $(".main--hasCategories");
	var $header = $(".header .header__inner");
	var $categoriesLink = $(".categories__link.scrool");

	function updateMargin() {
		// $header.css({
		// 	'box-shadow': 'none',
		// 	'border-bottom-width': '3px'
		// });

		$mainHasCategories.css({
			"margin-top": $header.outerHeight() + 13
		});
	}

	if ($mainHasCategories.length) {
		updateMargin();

		$(window).resize(function(event) {
			updateMargin();
		});
	}

	if ($categoriesLink.length) {
		$categoriesLink.click(function(event) {
			event.preventDefault();

			var anchor = $(this).attr('href');
			var headerHeight = $(".header").outerHeight();

	        $(window).scrollTo($("" + anchor + ""), 1000, {
	            interrupt: true,
	            offset: {
	                left: 0,
	                top: -(headerHeight + 15)
	            }
	        });
	    });
	}
}(jQuery));